import { useRef } from "react";
import { useHoverEffect } from "../hooks/useHoverEeffect";
import { useProjectLeftRightReveal } from "../hooks/gsap";
import SectionTitle from "./SectionTitle";

const data = {
  img1: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRIbUhDzOU6F4kTpaVFmWBrhCzS1j8oXJ6ihg&s",
  img2: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTGhWHQl6woULuqsfZ6gS4TRu0aSriVMruZ8w&s",
};

const About = () => {
  const aboutLeftRef = useRef(null);
  const aboutRightRef = useRef(null);
  const abouts = [aboutLeftRef, aboutRightRef];
  useHoverEffect(aboutLeftRef, data.img1, data.img2);
  useProjectLeftRightReveal(abouts);
  return (
    <div className="about container mx-auto mt-40" id="about">
      <SectionTitle title="About" />
      <div className="about-wrapper mt-40 grid grid-cols-1 lg:grid-cols-2  gap-20 overflow-hidden">
        <div className="about-left" ref={aboutLeftRef}></div>
        <div className="about-right" ref={aboutRightRef}>
          <p>
            I'm a passionate AI/ML student and full-stack developer with expertise in React, Next.js, 
            Node.js, and JavaScript. I love building intelligent applications that solve real-world 
            problems and bridge the gap between cutting-edge technology and practical solutions.
          </p>
          <p className="mt-10">
            <strong>Frontend Development:</strong> Proficient in modern frontend technologies including 
            React, Next.js, HTML, CSS, and JavaScript. I create responsive, user-friendly interfaces 
            with a focus on performance and accessibility.
          </p>
          <p className="mt-10">
            <strong>Backend & AI/ML:</strong> Experienced with Node.js for backend development and Python 
            for AI/ML projects. I work with TensorFlow, Scikit-learn, and Natural Language Processing 
            to build intelligent systems.
          </p>
          <p className="mt-10">
            <strong>Problem Solving:</strong> I enjoy tackling complex challenges and creating innovative 
            solutions. From temporary email services to AI-powered interview preparation tools, I build 
            applications that make a difference.
          </p>
          <a
            href="https://github.com/Kartikmhatre"
            target="_blank"
            rel="noreferrer"
            className=" inline-block mt-10 uppercase py-8 px-14 border border-white/20 rounded-full hover:bg-cyan-400/20 hover:border-cyan-400/20 duration-500"
          >
            View My Projects
          </a>
        </div>
      </div>
    </div>
  );
};

export default About;
